import { InnskraningState, VideoScene } from './types';

export const innskraningUrlEnum = {
  LOGIN: '/velkomin-i-vidskipti',
  ADDRESS: '/velkomin-i-vidskipti?skref=heimilisfang',
  ADD_ADDRESS: '/velkomin-i-vidskipti?skref=baeta-vid-heimilisfangi',
  SUMMARY: '/velkomin-i-vidskipti?skref=samantekt',
  SIGNATURE: '/velkomin-i-vidskipti?skref=undirskrift',
  SUCCESS: '/velkomin-i-vidskipti?skref=til-hamingju',
} as const;

export type InnskraningUrl = (typeof innskraningUrlEnum)[keyof typeof innskraningUrlEnum];

type BaseStep<
  Text extends string,
  URL extends InnskraningUrl,
  Index extends 0 | 1 | 2 | 3
> = {
  text: Text;
  number: Index;
  url: URL;
};

export type LoginStep = BaseStep<'Innskráning', (typeof innskraningUrlEnum)['LOGIN'], 0>;
export type AddressStep = BaseStep<
  'Heimilisfang',
  (typeof innskraningUrlEnum)['ADDRESS'],
  1
>;
export type AddAddressStep = BaseStep<
  'Bæta við heimilisfangi',
  (typeof innskraningUrlEnum)['ADD_ADDRESS'],
  1
>;
export type SummaryStep = BaseStep<
  'Samantekt',
  (typeof innskraningUrlEnum)['SUMMARY'],
  2
>;
export type SignStep = BaseStep<
  'Undirritun',
  (typeof innskraningUrlEnum)['SIGNATURE'],
  3
>;
export type SuccessStep = BaseStep<
  'Til hamingju',
  (typeof innskraningUrlEnum)['SUCCESS'],
  3
>;

const initialScene: VideoScene = {
  startTime: 0,
  endTime: 2.7,
  loop: false,
};

const transitionToRoomba: VideoScene = {
  startTime: initialScene.endTime,
  endTime: 5.01,
  loop: false,
};

const roombaStartLoop: VideoScene = {
  startTime: transitionToRoomba.endTime,
  endTime: 9.5,
  loop: true,
};

const roombaExitLoop: VideoScene = {
  ...roombaStartLoop,
  loop: false,
};

const transitionToAddressPicker = transitionToRoomba;

const addressPickerResults = roombaExitLoop;

const addressConfirm: VideoScene = {
  startTime: transitionToRoomba.endTime,
  endTime: roombaExitLoop.endTime,
  loop: false,
};

const transitionToNight: VideoScene = {
  startTime: roombaExitLoop.endTime,
  endTime: 14.7,
  loop: false,
};

const signatureComplete: VideoScene = {
  startTime: transitionToNight.endTime,
  endTime: 19,
  loop: false,
};

const loopDisco: VideoScene = {
  startTime: 19,
  endTime: 21.11,
  loop: true,
};

export const newTimeline = {
  initialScene,
  transitionToRoomba,
  transitionToAddressPicker,
  addressPickerResults,
  roombaStartLoop,
  roombaExitLoop,
  addressConfirm,
  transitionToNight,
  signatureComplete,
  loopDisco,
};

const loginStep: Readonly<LoginStep> = {
  text: 'Innskráning',
  url: innskraningUrlEnum.LOGIN,
  number: 0,
};

const addressStep: Readonly<AddressStep> = {
  text: 'Heimilisfang',
  url: innskraningUrlEnum.ADDRESS,
  number: 1,
};

const addAddressStep: Readonly<AddAddressStep> = {
  text: 'Bæta við heimilisfangi',
  url: innskraningUrlEnum.ADD_ADDRESS,
  number: 1,
};

const summaryStep: Readonly<SummaryStep> = {
  text: 'Samantekt',
  url: innskraningUrlEnum.SUMMARY,
  number: 2,
};

const signStep: Readonly<SignStep> = {
  text: 'Undirritun',
  url: innskraningUrlEnum.SIGNATURE,
  number: 3,
};

const successStep: Readonly<SuccessStep> = {
  text: 'Til hamingju',
  url: innskraningUrlEnum.SUCCESS,
  number: 3,
};

export const innskraningSteps = {
  [innskraningUrlEnum.LOGIN]: loginStep,
  [innskraningUrlEnum.ADDRESS]: addressStep,
  [innskraningUrlEnum.ADD_ADDRESS]: addAddressStep,
  [innskraningUrlEnum.SUMMARY]: summaryStep,
  [innskraningUrlEnum.SIGNATURE]: signStep,
  [innskraningUrlEnum.SUCCESS]: successStep,
} as const;

export const getInitialData = (isKassar: boolean): InnskraningState => {
  return {
    videoConfig: newTimeline.initialScene,

    selectedProperties: [],
    propertyDelivered: null,

    addresses: {
      address: '',
      postalCode: '',
      oldAddress: null,
      oldPostalCode: null,
    },

    user: {
      address: '',
      name: '',
      email: '',
      ssn: '',
      phoneNumber: '',
      reference: '',
    },

    error: {
      title: '',
      message: '',
    },

    isKassar,
    isLoggedIn: false,
    isCompleted: false,
    mailinglist: false,
    offerType: null,
  };
};
